// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"fd773fea","587":"fd773fea","690":"fd773fea","710":"c65ceb98"}[chunkId] + ".chunk.css";
};